import React, { useState } from "react";
import PropTypes from "prop-types";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

function CachePage({ onCachePageSumbit, closeCacheModal }) {
  const [value, setValue] = useState({ cacheUrl: "", cacheName: "" });

  const handleChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };


  const handleSubmit = async () => {
  const success = await onCachePageSumbit(value.cacheUrl, value.cacheName);
  if (success) {
    setValue({ cacheUrl: "", cacheName: "" });
    closeCacheModal();
  }
};

  return (
    <div style={{ padding: "0 0 24px", position: "relative" }}>
      <div style={{ position: "absolute", left: 16 }}>
        <Tooltip title="Back to table">
          <IconButton onClick={closeCacheModal} size="large">
            <ArrowBackRoundedIcon />
          </IconButton>
        </Tooltip>
      </div>

      <div
        style={{
          margin: "auto",
          width: "min(720px, 100%)",
          display: "grid",
          gap: 20,
          textAlign: "center",
        }}
      >
        <Typography
          style={{
            paddingTop: 16,
            fontSize: 22,
            fontWeight: 600,
          }}
        >
          Create new Cache Page
        </Typography>

        <TextField
          label="Step name"
          name="cacheName"
          value={value.cacheName}
          onChange={handleChange}
          variant="standard"
          fullWidth
        />

        <TextField
          label="Step URL"
          name="cacheUrl"
          value={value.cacheUrl}
          onChange={handleChange}
          variant="standard"
          fullWidth
        />

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            style={{ background: "#00badb", minWidth: 220 }}
            variant="contained"
            size="large"
            onClick={handleSubmit}
          >
            Create Cache Page
          </Button>
        </div>
      </div>
    </div>
  );
}

CachePage.propTypes = {
  onCachePageSumbit: PropTypes.func.isRequired,
  closeCacheModal: PropTypes.func.isRequired,
};

export default CachePage;
